import React, { useMemo } from 'react';
import { Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'hooks/apollo';
import { ALLOWED_FORMULA_VARIABLES_QUERY } from 'features/commissionCalculationMethods/queries';
import {
  AllowedFormulaVariablesCollapsedCard,
  AllowedFormulaVariablesTable,
  AllowedFormulaVariablesTableContainer,
  AllowedFormulaVariablesTableHeadContainer
} from 'features/commissionCalculationMethods/Styles';
import { Grid, TableBody, TableCell, TableRow } from '@mui/material';

const AllowedFormulaVariablesComponent = () => {
  const { t } = useTranslation();

  // #region Allowed formula variables

  const { data } = useQuery(ALLOWED_FORMULA_VARIABLES_QUERY);

  const variables = useMemo(() => (data && data.allowedFormulaVariables) || [], [data]);

  // #endregion

  return (
    <AllowedFormulaVariablesCollapsedCard
      subheader={
        <Typography variant='body2' fontWeight='bold'>
          {t('CommissionCalculationMethod.ListOfAllowedFormulas')}
        </Typography>
      }
      toggleOnHeaderClick
    >
      <AllowedFormulaVariablesTableHeadContainer container py={1} mb={1}>
        <Grid item xs={6} pl={1.5}>
          <Typography color='textPrimary' fontWeight='bold' variant='subtitle2'>
            {t('CommissionCalculationMethod.Name')}
          </Typography>
        </Grid>
        <Grid item xs={6} pl={0.5}>
          <Typography color='textPrimary' fontWeight='bold' variant='subtitle2'>
            {t('CommissionCalculationMethod.Description')}
          </Typography>
        </Grid>
      </AllowedFormulaVariablesTableHeadContainer>
      <AllowedFormulaVariablesTableContainer>
        <AllowedFormulaVariablesTable>
          <TableBody>
            {variables.map(variable => (
              <TableRow key={variable.name}>
                <TableCell>{variable.name}</TableCell>
                <TableCell>{variable.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </AllowedFormulaVariablesTable>
      </AllowedFormulaVariablesTableContainer>
    </AllowedFormulaVariablesCollapsedCard>
  );
};

export default AllowedFormulaVariablesComponent;
